import  { useState, useEffect } from 'react';
import ClockIcon from '../../assets/images/Clock.svg';
import CalendarIcon from '../../assets/images/Calendar.svg';
import LiveIcon from '../../assets/images/Live.svg';
import LiveTvIcon from '../../assets/images/LiveTvIcon.svg';
import { Tooltip } from 'antd';
import { TRAINING_CALENDAR_LINK, TRAINING_SESSIONS_JSON } from '../../constants';
import {  formatDisplayDate, getCurrentSession, getSessionState } from '../../helper';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../../segment';
import { Session } from '../../types/TeacherTrainingSession';
const TeacherTraining = () => {
  const sessions = TRAINING_SESSIONS_JSON
  const [currentTime, setCurrentTime] = useState(new Date());
  const [sessionData, setSessionData] = useState<{ currentSession: Session | null; withinOneWeek: boolean }>({ 
    currentSession: null, 
    withinOneWeek: false 
});
  const calendarLink = TRAINING_CALENDAR_LINK;
  const navigate = useNavigate();
  
  // Update time and session data
  useEffect(() => {
    const updateSessionData = () => {
      const now = new Date();
      setCurrentTime(now);
      const data = getCurrentSession(now, sessions);
      setSessionData(data);
    };
  
    // Initial update
    updateSessionData();
  
    // Update every minute 
    const timer = setInterval(updateSessionData, 60000);
  
    return () => clearInterval(timer);
  }, [sessions]);
  
  const { currentSession, withinOneWeek } = sessionData;
  // Handle view calendar click
  const handleViewCalendar = () => {
    trackEvent('click_view_training_calendar', {})
    window.open(calendarLink, '_blank');
  };

  // Handle join session click
  const handleJoinSession = () => {
    trackEvent('click_join_training_session',{})
    navigate('/lead-group-academy')
  };

  //early return if no upcoming or current session or no session within a week
  if (!currentSession || !withinOneWeek) {
    return (
      <></>
    );
  }

  const sessionState = getSessionState(currentSession,currentTime);
  const showJoinButton = sessionState === 'ongoing' || sessionState === 'starting_soon';

  return (
<div className="max-w-full absolute bottom-2 left-[10rem] rounded-[2rem] max-h-[8rem] drop-shadow-xl">
      <div className="w-full bg-white rounded-[2rem] shadow-sm border border-gray-200 overflow-hidden max-h-[8rem]">
        <div className="p-4 rounded-[2rem]">
          <div className="flex gap-x-[8rem] w-full">
            {/* Left side - Live indicator and content */}
            <div className="flex items-start gap-2">
              {/* Live indicator */}
              <div className="flex-shrink-0">
                <div className="bg-[#FFECEC] rounded-[4rem] p-3">
                    <img src={LiveIcon} alt="Live" className='w-6 h-6'/>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h2 className="text-[#666666] text-md mb-1">
                Upcoming live training for teachers on Lead Group Academy!
                </h2>
                
                <div className="flex flex-col sm:flex-row sm:flex-nowrap sm:items-center gap-3 text-base flex-nowrap font-bold text-[#222222]">
                  <div className="flex items-center gap-2 min-w-0">
                      <img src={LiveTvIcon} alt="LiveTvIcon" />
                      <Tooltip title={currentSession?.topic} placement="top">
                    <span className="font-semibold truncate max-w-[15rem]">
                      {currentSession?.topic}
                    </span>
                    </Tooltip>
                  </div>
                  
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <img src={CalendarIcon} alt="Calendar" />
                    <span className='font-semibold'>{formatDisplayDate(currentSession?.date)}</span>
                  </div>
                  
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <img src={ClockIcon} alt="Clock" />
                    <span className='font-semibold'>
                      {currentSession?.start_time} - {currentSession?.end_time}
                    </span>
                  </div>
                </div>

              </div>
            </div>

            {/* Right side - Action button */}
            <div className="flex items-center justify-center max-w-auto">
              {showJoinButton ? (
                <button
                  onClick={handleJoinSession}
                  className="w-full bg-gradient-to-r from-[#527FED] to-[#275BDD] hover:bg-blue-700 text-white font-medium px-16 py-3  lg:py-3 rounded-2xl transition-colors duration-200 flex items-center justify-center gap-2 shadow-sm text-lg"
                >
                  Join session
                </button>
              ) : (
                <button
                  onClick={handleViewCalendar}
                  className="w-full min-w-[4rem] bg-white hover:bg-gray-50 text-[#275BDD] font-medium px-5 py-3 rounded-2xl border-[1px] border-[#275BDD] transition-colors duration-200 shadow-sm"
                >
                  View Training Calendar
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherTraining;